// Export global constants for env variables
const ENV = process.env.ENV;

const LONGNOW_API_DOMAIN = process.env.LONGNOW_API_DOMAIN;
const GHOST_API_DOMAIN = process.env.GHOST_API_DOMAIN;
const GHOST_API_KEY = process.env.GHOST_API_KEY;

const STRIPE_API_KEY = process.env.STRIPE_API_KEY;

const IDEAS_SEARCH = process.env.IDEAS_SEARCH;
const ALGOLIA_INDEX_NAME = process.env.ALGOLIA_INDEX_NAME;
const ALGOLIA_APPLICATION_ID = process.env.ALGOLIA_APPLICATION_ID;
const ALGOLIA_API_KEY = process.env.ALGOLIA_API_KEY;

const RECAPTCHA_API_KEY = process.env.RECAPTCHA_API_KEY;

export {
  ENV,
  LONGNOW_API_DOMAIN,
  GHOST_API_DOMAIN,
  GHOST_API_KEY,
  STRIPE_API_KEY,
  IDEAS_SEARCH,
  ALGOLIA_INDEX_NAME,
  ALGOLIA_APPLICATION_ID,
  ALGOLIA_API_KEY,
  RECAPTCHA_API_KEY,
};
